import React, { PropsWithChildren, useEffect, useState } from 'react';


/**
 * @interface IEmbedTruthSocialProps declares any input properties required for this component.
 */
export interface IEmbedTruthSocialProps extends PropsWithChildren<unknown> {
  url: string;
  postWidth: number | string;
  postHeight: number | string;
}

/**
 * @function EmbedTruthSocial is a React functional component for displaying a TruthSocial social media post.
 * @param {} props are the properties passed into the component.
 */
export const EmbedTruthSocial: React.FC<IEmbedTruthSocialProps> = (props: IEmbedTruthSocialProps) => {
  EmbedTruthSocial.displayName = 'EmbedTruthSocial';

  // whether to display console logs (displayConsoleLogs && console.log statements)
  const displayConsoleLogs: boolean = false;

  displayConsoleLogs && console.log(`EmbedTruthSocial. Entered EmbedTruthSocial`);

  const { url, postWidth, postHeight } = props;

  // The script that is used to embed Truth Social posts.
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://truthsocial.com/embed.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <iframe src={url} className="truthsocial-embed" max-width={'100%'} width={postWidth} height={postHeight} allowFullScreen></iframe>
    </>
  )
}
